import {animate, style, transition, trigger} from '@angular/animations';

export const saveOverlay = trigger('saveOverlay', [
  transition(':enter', [
    style({opacity: '0', transform: 'translateY(30px)'}),
    animate(
      '0.4s cubic-bezier(.68,-1.6,.32,2.6)',
      style({
        opacity: '1',
        transform: 'translateY(0)',
      })
    ),
  ]),
  transition(':leave', [
    animate(
      '0.4s cubic-bezier(.68,-1.6,.32,2.6)',
      style({
        opacity: '0',
        transform: 'translateY(30px)',
      })
    ),
  ]),
]);
